import UserItem from "../../components/UserItem"
import { ClientInfo } from "../../api/users/data"
import CButton from "../../components/CButton"
import Label from "../../components/Label"
import CStack from "../../components/CStack"

type UserListItemProps = {
    users           :ClientInfo[] | null
    onLoadMore      : () => void
    onSelected      : (user: ClientInfo) => void
    showLoadMore?   : boolean
}

const UserListView:React.FC<UserListItemProps> =  
    ({users, onSelected, onLoadMore, showLoadMore = true}) => {
    return (<div className="client-list">
        <CStack header="">
        { users?.map( item => (<UserItem user={item} onClick={onSelected}/>))}
        {showLoadMore && <CButton onClick={onLoadMore}><Label textAlign="center">Load more</Label></CButton>}
        </CStack>
    </div>)
}

export default UserListView